import {
  Box,
  Heading,
  Text,
  Button,
  Stack,
  VStack,
  Link as ChakraLink,
  Image,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import msmelogo from "../../../assets/images/msme.png";

const Footer = () => {
  const bg = "black";
  const textMuted = "gray.400";

  return (
    <>
      <Box bg={bg} color="white" px={[1, 10, 20]} pt={20} pb={10} position="relative">
        {/* ================= TOP CONTENT ================= */}
        <Stack
          direction={["column", "row"]}
          justify="space-between"
          align={["flex-start", "flex-start"]}
          spacing={16}
          zIndex={2}
          position="relative"
        >
          {/* LEFT BLOCK */}
          <VStack align="flex-start" spacing={6} p={6} maxW="520px">
            <Heading
              fontFamily="Bricolage Grotesque"
              fontSize={["3xl", "4xl", "5xl"]}
              fontWeight="900"
              lineHeight="1.2"
              color={"white"}
            >
              Grapple First. <br />
              Execute Better.
            </Heading>

            <Button
              as="a"
              href="https://tally.so/r/obeQab"
              target="_blank"
              rel="noopener noreferrer"
              size="lg"
              bg="white"
              color="black"
              borderRadius="none"
              px={10}
              _hover={{ bg: "gray.200" }}
              rightIcon={<span>→</span>}
            >
              Let's Talk
            </Button>

            <Box p={6}>
              <Text fontSize="sm" color={textMuted}>
                Reach out us via:
              </Text>
              <Text fontSize="md" fontWeight="600">
                support@grappl-tech.in
              </Text>
            </Box>
          </VStack>

          {/* RIGHT BLOCK */}
          <Stack direction={["column", "row"]} p={6} spacing={20}>
            {/* NAV LINKS */}
            <VStack align="flex-start" spacing={2}>
              {[
                { label: "Home", path: "/" },
                { label: "Tech in Week", path: "/techinweek" },
                { label: "Bootcamps", path: "/bootcamps" },
                { label: "Portfolio Services", path: "/portfolio-services" },
                { label: "Workshops", path: "/workshops" },
                { label: "Outsourcing", path: "/outsourcing" },
                { label: "Partner Registration", path: "/partnerregistration" },
                { label: "About", path: "/about" },
                { label: "Careers", path: "/careers" },
                { label: "Contact", path: "/contact" },
              ].map((item) => (
                <ChakraLink
                  key={item.path}
                  as={Link}
                  to={item.path}
                  fontSize="sm"
                  _hover={{ textDecoration: "underline" }}
                >
                  {item.label}
                </ChakraLink>
              ))}
            </VStack>

            {/* SOCIAL + LEGAL */}
            <VStack align="flex-start" spacing={3}>
              <ChakraLink href="https://www.linkedin.com/company/grappltech/" isExternal>
                LinkedIn ↗
              </ChakraLink>
              <ChakraLink href="https://twitter.com/internpixel" isExternal>
                Twitter ↗
              </ChakraLink>
              <ChakraLink
                href="https://www.youtube.com/@GrapplTech%E0%B0%A4%E0%B1%86%E0%B0%B2%E0%B1%81%E0%B0%97%E0%B1%81"
                isExternal
              >
                YouTube ↗
              </ChakraLink>

              <Box pt={6}>
                <Text fontSize="sm">India, USA</Text>
                <Text fontSize="sm">Remote-first</Text>
              </Box>

              <Box pt={4}>
                <ChakraLink
                  as={Link}
                  to="/terms-conditions"
                  fontSize="sm"
                  display="block"
                  _hover={{ textDecoration: "underline" }}
                >
                  Terms & Conditions
                </ChakraLink>
                <ChakraLink
                  as={Link}
                  to="/privacy-policy"
                  fontSize="sm"
                  display="block"
                  _hover={{ textDecoration: "underline" }}
                >
                  Privacy Policy
                </ChakraLink>
              </Box>
            </VStack>
          </Stack>
        </Stack>

        {/* ================= BOTTOM LINE ================= */}
        <Box p={6}>
          <Box display="flex" alignItems="center" gap={4}>
            <Text fontSize="xs" color={textMuted}>
              © {new Date().getFullYear()} GrapplTech. Built with intent.
            </Text>
            <Image
              src={msmelogo}
              alt="MSME Registered"
              h="28px"
              w="auto"
              opacity={0.6}
              _hover={{ opacity: 1 }}
              transition="opacity 0.2s"
            />
          </Box>
        </Box>

        <Box
          mt={4}
          position="relative"
          overflow="hidden"
          zIndex={1}
          textAlign="center"
        >
          <Text
            fontFamily="Bricolage Grotesque"
            fontSize="clamp(4rem, 18vw, 32rem)"
            fontWeight="800"
            lineHeight="0.9"
            letterSpacing="-0.02em"
            color={"white"}
            userSelect="none"
            whiteSpace={["normal", "nowrap"]}
            wordBreak="break-word"
          >
            grappltech
          </Text>
        </Box>
      </Box>
    </>
  );
};

export default Footer;